<template>
    <div class="modal fade in" style="display:block;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">

                <div class="modal-header">
                    <button class="close" @click="$emit('close')">&times;</button>
                    <h4 class="modal-title">Sync Data dari User</h4>
                </div>

                <div class="modal-body">
                    <p>
                        Data berikut akan disalin dari akun User ke data Pengunjung.
                        Field yang kosong di Pengunjung akan diisi otomatis.
                    </p>

                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <th>Field</th>
                            <th>User</th>
                            <th>Member</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="field in fields" :key="field.key">
                            <td>{{ field.label }}</td>
                            <td>{{ user[field.key] ?? '-' }}</td>
                            <td>{{ member[field.key] ?? '-' }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-default" @click="$emit('close')">
                        Batal
                    </button>
                    <button class="btn btn-warning" @click="sync" :disabled="isLoading">
                        <i class="fa fa-refresh" /> Sinkronkan
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        member: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            user: {},
            fields: [
                { key: 'name', label: 'Nama Lengkap' },
                { key: 'email', label: 'Email' },
                { key: 'phone', label: 'No. Telpon' },
                { key: 'birthdate', label: 'Tanggal Lahir' },
                { key: 'address', label: 'Alamat' },
            ]
        };
    },
    created() {
        axios.get(`/api/users/email/${this.member.email}`, {
            params: { email: this.member.email }
        }).then(res => {
            this.user = res.data.data;
            this.user.birthdate = res.data.data.dob;
        });
    },
    methods: {
        sync() {
            this.isLoading = true;
            axios.post(`/api/visitors/${this.member.id}/sync`)
                .then(res => {
                    this.$emit('synced', res.data.data);

                    window.location.assign(window.location.href);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};

</script>
